
<template>
  <div class="grid-row">
      <div class="c-12 c-xs-12 c-sm-12 c-md-12 c-lg-12">
        <div class="payment accepted" v-if="payment_status === 'accept'">
          <CustomModal 
            :type="'success'"
            :open="open_modal"
            @close-modal="open_modal = false">
              <template slot="modal_content">
                <p class="notification-text">{{success_message}}</p>
              </template>
              <template slot="modal_footer">
                <div class="btn-modal">
                  <span @click="vValidate" class="btn">OK</span>
                </div>
              </template>
          </CustomModal>
        </div>
        <div class="payment leave" v-else-if="payment_status === 'denied'">
          <CustomModal 
            :type="'error'"
            :open="open_modal"
            @close-modal="open_modal = false">
              <template slot="modal_content">
                <p class="notification-text">{{error_message}}</p>
              </template>
              <template slot="modal_footer">
                <div class="btn-modal">
                  <span @click="vValidate" class="btn">OK</span>
                </div>
              </template>
          </CustomModal>
        </div>
      </div>
  </div>
</template>

<script>

import CustomModal from '@/common/components/widget/Modal/CustomModal';

export default {
  name: 'PaymentStatus',
  data() {
    return {
      payment_status: '',
      success_message: this.$_('payment_success'),
      error_message: this.$_('payment_abort'),
      open_modal: true,
    }
  },
  components: {
    CustomModal
  },
  created() {
    this.payment_status = this.$route.meta.payment_status;
  },
  methods: {
    vValidate() {
      this.$router.push('/');
    }
  }
}
</script>

<style scoped>
.notification-text {
  text-align: center;
}
.btn-modal {
  display: flex;
  justify-content: center;
}

</style>